// extracted by mini-css-extract-plugin
export default {"container":"AccountLanguage--container--982ce8","icon":"AccountLanguage--icon--7158ff","label":"AccountLanguage--label--a40737"};